// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEngagementSegmentsTagsResult = objectOf({
  all_tags: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
  used_tags: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});
